import {
  ADD_TOAST,
  REMOVE_TOAST,
  ToastActionType,
  ToastState
} from "./types";

const initialState: ToastState = {
  toasts: []
}

export function ToastReducer(
  state: ToastState = initialState,
  action: ToastActionType
): ToastState {
  switch (action.type) {
    case ADD_TOAST: {
      const { payload: { toast } } = action;
      const { toasts } = state;

      const updatedToasts = [toast, ...toasts];

      return {
        ...state,
        toasts: updatedToasts
      };
    }

    case REMOVE_TOAST: {
      const { payload: { toastId } } = action;
      const { toasts } = state;

      const updatedToasts = toasts.filter((toast => {
        return toast.id != toastId
      }));

      return {
        ...state,
        toasts: updatedToasts
      };
    }

    default: {
      return state;
    }
  }
}
